import { TextField } from '@mui/material';
import { Field } from 'src/API';
import { FieldInput, FIELD_TYPES, FileUploadProperties } from 'src/api/process-module';

interface FileUploadFieldProps {
  field: FieldInput & Partial<Field>;
  index: number;
  handleFieldChange: (index: number, field: Partial<FieldInput & Partial<Field>>) => void;
  isSubmitting: boolean;
  isUsingExistingField: boolean;
}

export const FileUploadField = ({
  field,
  index,
  handleFieldChange,
  isSubmitting,
  isUsingExistingField,
}: FileUploadFieldProps) => {
  const properties = field.properties as FileUploadProperties;

  return (
    <>
      {/* <TextField
        fullWidth
        label="Accepted File Types"
        value={properties?.acceptedTypes || ''}
        onChange={(e) =>
          handleFieldChange(index, {
            properties: {
              ...properties,
              type: FIELD_TYPES.FILE_UPLOAD,
              acceptedTypes: e.target.value,
            } as FileUploadProperties,
          })
        }
        disabled={isSubmitting || isUsingExistingField}
        helperText="Enter comma-separated list of accepted file types (e.g., .pdf,.doc,.docx)"
      /> */}
    </>
  );
};
